<template>
  <div class="sale-chart">
    <div class="sale-chart__header">
      <div class="text_large">{{ i18n.sale_investment_history() }}</div>
    </div>

    <div class="sale-chart__container">

      <div class="sale-chart__labels">
        <scale-tabs
          :asset="asset"
          v-model="scale"
          :isPending="isPending"
        />
      </div>

      <d3-chart class="sale-chart__chart" :data="history" :currency="asset" :scale="scale" :isPending="isPending"
                :precision="precision" v-if="history.length" :requiredTicks="requiredTicks"/>
      <div class="chart-container__loader" v-else>Loading...</div>

    </div>
  </div>

</template>

<script>
  import D3Chart from './ChartWidget.ChartRenderer'
  import ScaleTabs from './ChartWidget.DateTabs'
  import { i18n } from '@js/i18n'
  import { mapGetters } from 'vuex'
  import { vuexTypes } from '@vuex/types'

  export default {
    name: 'chart',

    components: {
      ScaleTabs,
      D3Chart
    },

    props: {
      data: { type: Object, required: true },
      asset: { type: String, required: false },
      action: { type: String, default: 'issued' },
      currentCap: { type: [String, Number], required: false },
      hardCap: { type: [String, Number], required: false },
      softCap: { typ: [String, Number], required: false },
      precision: { type: Number, default: 0 }
    },

    data () {
      return {
        scale: 'month',
        isPending: false,
        i18n,
        tokenCode: null
      }
    },

    created () {
      this.tokenCode = this.tokenCodes[0] || null
    },

    computed: {
      ...mapGetters([
        vuexTypes.userWithdrawableTokens,
        vuexTypes.accountBalances
      ]),
      tokenCodes () {
        return this.userWithdrawableTokens.map(token => token.code)
      },
      history () {
        if (!this.data[this.scale]) return []
        return this.data[this.scale]
      },
      requiredTicks () {
        return [this.softCap, this.hardCap].filter(value => value)
      },
      balance () {
        return this.accountBalances[this.tokenCode]
      }
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  @import "~scss/mixins";
  @import "~scss/variables";

  .sale-chart {

    &__header {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;

      &_balance {
        color: $col-text-secondary;
      }
    }

    &__labels {
      display: flex;
      justify-content: space-between;
      flex-wrap: nowrap;
      margin: 16px 0;
    }

    &__chart {
      padding: 12px;

      & /deep/ svg text {
        color: $col-text-secondary;
        fill: $col-text-secondary;
        font-size: 16px;
      }
    }
  }

  .chart-container__loader {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/sales/sale_details/components/chart/ChartWidget.Index.vue